module.exports = __webpack_public_path__ + "static/media/6.3dcf29b2.jpg";